<template>
  <div class="container">
    <div class="contain">
      <div class="contain-img"><span>用户登录</span><img src="../../static/img/bg44.png" alt=""></div>
      <div class="denglu">
        <div class="dengluk">

          <ul>
            <li>

              <label>
                <input
                  id="phone"
                  type="phone"
                  v-model="phone"
                  placeholder="请输入手机号"
                  style="border-left: 0px"
                  maxlength="15"
                />
              </label>
            </li>

            <li style="height:70px;display:flex;justify-content:space-between;margin-top:45px">

              <label style="min-width: 60%;width:40%;margin-left: 5px;">
                <input
                  id="code"
                  type="text"
                  name
                  v-model="person.code"
                  placeholder="填写验证码"
                  style="border-left: 0px;width: 100px;"
                  maxlength="10"
                />
              </label>
              <a
                id="btnSendCode"
                href="javascript:void(0);"
                class="yzm"
                @click="SendPhoneCode(this)"
              >
                <img :src="imgCode" alt="" style="width:70%; margin:0 auto; ">
              </a>
            </li>
            <li>
              <div class="dltbn" style="width: 76%" @click="register()">立即登录</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      isSend: false,
      phone: "",
      password: "",
      passwords: "",
      code: "",
      buttonmsg: "点击发送验证码",
      flag: false,
      codes: "",
      zhud: false,
      loading: false,
      webapi:window.SITE_CONFIG.baseApiUrl,
      imgCode:"",
      code: "", //验证码
      person:{
        id:"",
        code:"",
      }
    };
  },
  computed: {


    usertel() {
      if (this.tel === "") {
        return "";
      } else if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.tel)) {
        return "手机号格式错误";
      } else {
        return "";
      }
    },

    test() {
      if (this.code === "") {
        return "";
      } else if (this.code.length !== 5) {
        return "验证码格式错误";
      } else {
        return "";
      }
    }
  },
  mounted(){
      this.getImgCode();
  },
  methods: {

        //获取图片验证码
    getImgCode(){
      var that=this;
     this.$http
          .get(that.webapi+"wxshopapi/VierificationCode")
          .then(res => {
            that.imgCode=res.data.result.img
            this.person.id=res.data.result.id



          });
    },

    inLogin(){
      var that=this;
    this.$http
          .get(""+that.webapi+"wxshopapi/UserInfo/GetLoginByPhone?phone="+that.phone+"&code="+that.person.code+" ")
          .then(res => {
         var data=JSON.parse(res.data.result)
         sessionStorage.setItem("info",JSON.stringify(data));
         sessionStorage.setItem("Status", 1);
         sessionStorage.setItem("phone",this.phone);
                 this.$router.push({  path: "/",});
          });
    },
    toLogin() {
      this.$router.replace("/login");
    },

    SendPhoneCode() {
      this.getImgCode();
      // let time = 60;
      // let timer;
      // console.log(timer);
      // timer = setInterval(() => {
      //   time--;
      //   if (time === 0) {
      //     clearInterval(timer);
      //     this.flag = false;
      //     this.buttonmsg = "点击发送验证码";
      //     return;
      //   }
      //   this.flag = true;
      //   this.buttonmsg = time + "秒后重新发送";
      // }, 1000);
      // this.getCode();
    },
    getCode() {

      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone) || this.phone === "") {
        Toast("手机号码输入有误");
      } else {
        this.$http
          .get("/yxapi/api/UserApi/GetSendPhoneCode", {
            phone: this.phone
          })
          .then(res => {
            if (JSON.parse(res.data).Status === true) {
                sessionStorage.setItem("phone",JSON.parse(res.data).Result.moblie);
              this.$message({
                message: "发送成功",
                type: "success"
              });
            } else {
              this.$message.error("获取验证码失败");
            }

          });
      }
    },
    register() {
      var that=this;
      if(this.phone===""){
          this.$message({
              message: "手机号不能为空",
              type: "error"
            });
            return;
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone) ) {
         this.$message({
              message: "手机号输入有误",
              type: "error"
            });
            return;
      }
      if(this.person.code==""){
             this.$message({
              message: "验证码输入不能空",
              type: "error"
            });
            return;
      }

      this.$https
        .post(that.webapi+"wxshopapi/VierificationCode",{
          id:this.person.id,
          code:this.person.code
      })
        .then(res => {
            if(res.data.success==true){
       this.$message({
              message: "登录成功",
              type: "success"
            });
            this.inLogin();

            }else{

              this.$message.error(res.data.msg);
            }

        });


    }
  }
};
</script>
<style scoped>
.container{
width: 80%;
    margin: 50px auto;
}
.denglu {
  width: 100%;
  height: 100%;
  overflow: hidden;
  float: left;
  position: relative;
}
.contain-img img{
  width: 69px;
  height: 74px;
}
.contain-img{
  display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.contain-img span{
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}
/*  */
.dengluk h1 {
width: 96%;
    height: 43px;
    line-height: 40px;
    /* float: left; */
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}
.dengluk ul {
  width: 100%;
  height: auto;
  overflow: hidden;
  float: left;
}
.dengluk li {
  width: 100%;
  height: 43px;
  line-height: 40px;
  float: left;
  margin-top: 20px;
}
.dengluk li span {
  /* width: 65px; */
  float: left;
  height: 40px;
  line-height: 43px;
  letter-spacing: 2px;
  text-align: center;
  color: #333;
  font-size: 14px;
}
.dengluk li label {
  width: 98%;
  height: 40px;
  float: right;
  border: 1px solid #c1c1c1;
  min-width: 300px;
  border-radius: 3px;
}
.dengluk li label input {
  width: 267px;
  height: 30px;
  background: #fff;
  border: 0px;
  margin: 5px 0px;
  padding-left: 20px;
  border-left: 1px solid #c1c1c1;
  font-size: 14px;
  color: #333;
}
.dltbn {
  width: 83%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  font-size: 17px;
  letter-spacing: 1em;
  background: #20a3fe;
  display: block;
  /* float: right; */
  border-radius: 20px;
  margin: 0 auto;
}
.yzm {
  width: 140px;
  height: 40px;
  line-height: 40px;
  display: block;
  float: right;
  text-align: center;
  /* border: 1px solid #20a3fe; */
  color: #20a3fe;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/enter.vue